import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../services/data.service';

@Component({
	selector: 'app-modules',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
	templateUrl: './modules.component.html',
	styleUrl: './modules.component.scss',
})
export class ModulesComponent {
	datePipe = inject(DatePipe);
  base = 'modules';		// important for API calls
	loading = false;
	isEdit = false;
	allData: any = [];
	today = new Date().toISOString().split('T')[0];
  defaultMOD: any = [];

	frmData: any = {
    id: null,
		code: '', 
		m_name: '', 
		description: '', 
		m_price: 0,
		q_price: 0,
		h_price: 0,
		a_price: 0,
		sort_no: 0, 
		is_active: true
	}

  constructor(public dataService: DataService) {
    //
  }

  ngOnInit() {
    this.defaultMOD = this.dataService.menuData.mainMenu.filter((mm: any) => {
      return mm.for_module;
    });

    this.loading = true;
    this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res;
      this.loading = false;
    });
	}

  getCodeName(e: any) {
    let mmv: any = e.target.value;

    this.defaultMOD.filter((mm: any) => {
      if(mm.optClick === mmv) {
        this.frmData.code = mm.optClick; 
        this.frmData.m_name = mm.title;
      }
    });
  }

  newClick() {
    this.isEdit = false;
		this.resetForm();
  }

  editClick(myData: any) {
    this.isEdit = true;
		this.frmData = Object.assign({}, myData);
		this.frmData.valid_from = myData.valid_from;
		this.frmData.valid_until = myData.valid_until;
  }

	resetForm() {
		this.isEdit = false;
		this.frmData = {
			id: null,
			code: '', 
			m_name: '', 
			description: '', 
			m_price: 0,
			q_price: 0,
			h_price: 0,
			a_price: 0,
			sort_no: 0, 
			is_active: true
		}
	}

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
				this.isEdit = false;
        this.resetForm();
				this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
				this.isEdit = false;
        this.resetForm();
				this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

}
